var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partial partial--help help"},[_c('div',{staticClass:"partial__heading"},[_c('ion-icon',{staticClass:"partial__icon",attrs:{"name":"help-buoy","size":"large"}}),_c('h1',{staticClass:"partial__title"},[_vm._v("Help & Support")])],1),_c('form-support',{staticClass:"support__form"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }